import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../../firebase';
import '../event/archive_event.css';

const ArchiveEventDetail = () => {
  const { eventId } = useParams(); // 🟢 Extracts "event_001" directly from your active URL
  const navigate = useNavigate();
  const [eventData, setEventData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEventDetails = async () => {
      try {
        // Query the collection where the field event_id matches the URL parameter
        const q = query(collection(db, "parmEvent"), where("event_id", "==", eventId));
        const snap = await getDocs(q);

        if (!snap.empty) {
          // Since event_id is unique, take the first document match
          setEventData(snap.docs[0].data());
        } else {
          console.error("No matching archived event found!");
        }
      } catch (err) {
        console.error("Error fetching details:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchEventDetails();
  }, [eventId]);

  if (loading) return <div className="loader">Loading event profile...</div>;
  if (!eventData) return <div className="error-state">Event profile not found. <button onClick={() => navigate('/archive-event-list-parm')}>Back to Archive</button></div>;

  // Formatting date safely
  const formattedDate = eventData.event_date?.seconds
    ? new Date(eventData.event_date.seconds * 1000).toLocaleDateString('en-MY', { year: 'numeric', month: 'long', day: 'numeric' })
    : eventData.event_date;

  return (
    <article className="archive-event-detail-page">
      <div className="archive-detail-container">
        <button onClick={() => navigate('/archive-event-list-parm')} className="back-btn">⬅ Back to Archives</button>
        
        <header className="archive-event-header">
          <h1>{eventData.event_title}</h1>
          <p className="archive-detail-date">📅 Event Date: {formattedDate}</p>
        </header>

        <hr />

        <section className="archive-event-body">
          {/* Main Description */}
          <div className="archive-event-description">
            <h3>About the Event</h3>
            <p style={{ whiteSpace: 'pre-line' }}>{eventData.event_description || "No description provided."}</p>
          </div>

          {/* 🟢 IMAGE GALLERY LAYOUT */}
          {eventData.event_image_array && eventData.event_image_array.length > 0 && (
            <div className="archive-event-gallery-section">
              <h3>Event Media Gallery</h3>
              <div className="archive-gallery-grid">
                {eventData.event_image_array.map((imgUrl, index) => (
                  <div key={index} className="archive-gallery-item">
                    <img 
                      src={imgUrl} 
                      alt={`${eventData.event_title} snapshot ${index + 1}`} 
                      onClick={() => window.open(imgUrl, '_blank')} // Simple lightbox fallback zoom effect
                      loading="lazy"
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </section>
      </div>
    </article>
  );
};

export default ArchiveEventDetail;